
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/category/[slug]/[page]",
      function () {
        return require("private-next-pages/category/[slug]/[page].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/category/[slug]/[page]"])
      });
    }
  